import { InfoCircleOutlined } from '@ant-design/icons';
import { Disclosure, Transition } from '@headlessui/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Collapse = ({
    title,
    icon,
    children,
    error,
    defaultOpen = false,
    onClick,
}) => {
    return (
        <Disclosure defaultOpen={defaultOpen}>
            {({ open }) => (
                <>
                    <Disclosure.Button
                        onClick={onClick}
                        disabled={open && error}
                        className={classNames(
                            'h-10 px-4 inline-flex items-center gap-x-2 text-sm font-medium focus:z-10',
                            'focus:outline-none disabled:opacity-50 disabled:pointer-events-none rounded-t-md',
                            'border border-gray-200 bg-white text-gray-800 shadow-sm transition-all duration-300',
                            'dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:bg-neutral-800',
                            {
                                'bg-[#FFF8F9] text-[#95A0A8]': error,
                                'text-[#95A0A8]': !error && !open,
                            }
                        )}
                    >
                        <div className="flex items-center space-x-2 font-semibold text-base text-purple">
                            {icon}
                            <span className="flex items-center space-x-2">
                                <span>{title}</span>
                                {error && (
                                    <InfoCircleOutlined className="text-[#F0536F]" />
                                )}
                            </span>
                        </div>
                    </Disclosure.Button>
                    <Transition
                        show={open}
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                    >
                        <Disclosure.Panel className="flex flex-col">
                            {children}
                        </Disclosure.Panel>
                    </Transition>
                </>
            )}
        </Disclosure>
    );
};
Collapse.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    children: PropTypes.node,
    error: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    onClick: PropTypes.func,
};

export default Collapse;
